<template>
  <el-form :inline="true"
    :model="formInline"
    class="demo-form-inline">
    <el-form-item label="计划执行时间">
      <el-select v-model="formInline.screen"
        collapse-tags
        placeholder="请选择筛选条件">
        <el-option v-for="item in screenList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="搜索">
      <el-input v-model="formInline.searchTxt"
        placeholder="请输入内容"
        clearable>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary"
        @click="submitBtn">查询</el-button>
      <el-button type="warning"
        icon="el-icon-plus"
        v-if="judgeAuthority('houqinguanli:baoyangguanli:maintainPlan:edit')"
        @click="handleAdd">新增保养计划</el-button>
      <el-button type="primary" plain
        v-if="judgeAuthority('houqinguanli:baoyangguanli:maintainPlan:export')"
        @click="$parent.exportExcel()"><i class="el-icon-download el-icon--left"></i>EXCEL</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { judgeAuthority } from "@/assets/js/utils";
export default {
  data() {
    return {
      screenList: [
        { value: "", label: "全部计划" },
        { value: "DAY", label: "今日计划" },
        { value: "WEEK", label: "本周计划" },
        { value: "MONTH", label: "本月计划" },
      ],
      formInline: {
        searchTxt: "",
        screen: "",
      },
    };
  },
  methods: {
    judgeAuthority,
    submitBtn() {
      this.$emit("getFormBtn", {
        searchTxt: this.formInline.searchTxt,
        typeValue: this.formInline.screen,
        plan: "",
      });
    },
    handleAdd() {
      this.$emit("handleAddEdit", { title: "新增计划" });
    },
  },
  created() {
    this.formInline.searchTxt = this.$route.query.name ?? "";
    this.$emit("getFormBtn", {
      searchTxt: this.formInline.searchTxt,
      typeValue: this.formInline.screen,
      planId: this.$route.query.id ?? "",
    });
  },
};
</script>

<style>
</style>